export enum OutreachPanelPage {
  Labels = 'Labels',
  Outreach = 'Outreach',
}
